import React from 'react';

export interface PermissionInfoCellProps {
  displayName: string;
  name: string;
}

export const PermissionInfoCell: React.FC<PermissionInfoCellProps> = ({
  displayName,
  name
}) => {
  return (
    <div className="flex flex-col">
      <div className="text-sm font-medium text-text-primary">
        {displayName}
      </div>
      <code className="text-xs text-text-secondary">
        {name}
      </code>
    </div>
  );
};
